var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag || 'p',{tag:"component",class:_vm.classString,attrs:{"element-translation":_vm.i18n ? _vm.elementTranslation.found : _vm.elementTranslation.missing},domProps:{"innerHTML":_vm._s(_vm.translatedContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }